import { EmptyState } from '@myhome/ui/patterns/empty-state';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_shell/settings')({
  component: Page,
});

function Page() {
  return (
    <div className="flex flex-col gap-5">
      <h1 className="font-heading text-headline font-semibold text-navy-900">Settings</h1>
      <EmptyState
        title="Settings"
        description="Admin users and the terms and privacy versions arrive with the admin feature."
      />
    </div>
  );
}
